import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.scss']
})
export class ForgotPasswordDialogComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  randomNumber: string;
  numberMatch: boolean;

  constructor(private fb: FormBuilder, private commonService: CommonService, private toastr: ToastrService ) { }
  submitted: boolean;
  spinner: boolean;
  showLogin: boolean;
  user: any;

  ngOnInit() {
    this.buildForgotPasswordForm();
    this.randomNumber = Math.floor(1000 + Math.random() * 9000).toString();
  }

  /**
  * Name: hasError
  * purpose: To check if form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasError(control: any): boolean {
    return (
      control &&
      (this.submitted || control.touched || control.dirty) && !control.valid);
  }

  /**
  * Name: buildForgotPasswordForm
  * purpose: To create customer data form
  */
  buildForgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      UserId: ['', Validators.required],
      EmailId: ['', Validators.required],
      captchaNumber:['']
    });
  }

 /**
  * Name: sendEmail
  * purpose: To Send email to user
  */
  sendEmail(): void {
    let f = this.forgotPasswordForm;
    this.submitted = true;
    if (f.valid) {
      if(this.randomNumber==f.value.captchaNumber){
        this.numberMatch=false
        let username = f.value.UserId;
      let emailId = f.value.EmailId;
      this.spinner = true;
      this.commonService.forgotPassword(username, emailId)
        .subscribe(res => {
          if (res['responseCode'] == 0) {
            this.toastr.info(res['message']);
          } else {
            this.spinner = false;
            this.submitted = false;
            this.toastr.error(res['message'], "Error");
          }
        }, error => {
          this.spinner = false;
          this.submitted = false;
          this.toastr.error(error, "Error");
        });
      }else{
        this.randomNumber = Math.floor(1000 + Math.random() * 9000).toString();
        this.numberMatch=true
        this.submitted = false;
      }

    }else{
      this.submitted=false;
      this.forgotPasswordForm.markAllAsTouched();
    }
  }

  refreshCaptcha(){
    this.randomNumber = Math.floor(1000 + Math.random() * 9000).toString();
  }

}
